<template>
<!--  更换底色-->
  <div class="background-wrapper">
    <div
      class="background-item"
      v-for="(item, index) in tabDataBackground"
      :class="{active: item.en === activeBg}"
      :key="`tab_bg_${item.en}_${index}`"
      @click="handleClickBg(item)">
      <div class="color-box" :class="item.en" />
    </div>
  </div>
</template>

<script>
import active from "@/views/questionnaire/active.vue";

export default {
  props: {
    activeBg: {
      type: String,
      default: "white",
    }
  },
  data() {
    return {
      tabDataBackground: [ // 更改底色 可选数据
        {
          cn: '蓝色',
          en: 'blue'
        },
        {
          cn: '白色',
          en: 'white'
        },
        {
          cn: '浅蓝',
          en: 'baby_blue'
        },
        {
          cn: '红色',
          en: 'red'
        },
        {
          cn: '深蓝',
          en: 'navy_blue'
        },
        {
          cn: '灰色',
          en: 'grey'
        }
      ],
    }
  },
  methods: {
    handleClickBg(obj) {
      if (obj.en !== this.activeBg.en) {
        this.$emit('submit', obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.background-wrapper {
  width: 100%;
  height: 100%;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 15px;
  //overflow: auto;
  .background-item {
    width: 60px;
    height: 55px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    &.active {
      border: 1px solid #4dbb68;
      .white {
        //border: none!important;
      }
    }
    .color-box {
      width: 47px;
      height: 47px;
      border-radius: 6px;
      &.blue {
        background: #578DD4;
      }

      &.white {
        background: #FFFFFF;
        border: 1px solid #ECECEC;
        //&::after {
        //  top: -6px;
        //  left: -6px;
        //}
      }

      &.baby_blue {
        background: #71B4FF;
      }

      &.red {
        background: #E94024;
      }

      &.navy_blue {
        background: #2E527A;
      }

      &.grey {
        background: #676B7C;
      }
    }
  }
}
</style>
